<template>
  <div>
    <Nav />
    <div class="register-new">
      <div id="content">
        <div class="register">
          <div class="wrapper">
            <div class="inner">
              <div class="main">
                <h1 class="main-title">Registration</h1>
                <sui-form autocomplete="off" class="ui form">
                  <p class="required-text">
                    <span>*</span>Required information
                  </p>
                  <div class="list">
                    <sui-form-field required>
                      <label>Name</label>
                      <div class="two-fields">
                        <sui-form-field>
                          <input
                            type="text"
                            name="shipping[first-name]"
                            placeholder="First Name"
                          />
                        </sui-form-field>
                        <sui-form-field>
                          <input
                            type="text"
                            name="shipping[last-name]"
                            placeholder="Last Name"
                          />
                        </sui-form-field>
                      </div>
                    </sui-form-field>
                    <sui-form-field required>
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                      />
                    </sui-form-field>
                    <sui-form-field>
                      <label>LinkedIn URL</label>
                      <input
                        type="text"
                        name="linkedin"
                        placeholder="Please provide us your LinkedIn URL"
                      />
                    </sui-form-field>
                    <sui-form-field>
                      <label>LINE ID</label>
                      <input
                        type="text"
                        name="line"
                        placeholder="Please provide us your LINE ID"
                      />
                    </sui-form-field>
                    <sui-form-field>
                      <label>Phone No.</label>
                      <input
                        type="text"
                        name="phone"
                        placeholder="Enter your phone number"
                      />
                    </sui-form-field>
                    <sui-form-field required>
                      <label>How long have you been a recruiter?</label>
                      <sui-dropdown
                        v-model="current"
                        placeholder="Please select one answer"
                        selection
                        :options="options"
                      />
                    </sui-form-field>
                    <sui-form-field required>
                      <label
                        >Which industry are you specialized in?
                        <span class="field-note"
                          >(Can select more than 1)</span
                        ></label
                      >
                      <ul class="checkbox-group">
                        <li class="item">
                          <input id="" type="checkbox" name="industry" />
                          <span class="item-text">Information Technology</span>
                        </li>
                        <li class="item">
                          <input id="" type="checkbox" name="industry" />
                          <span class="item-text">Telecommunications</span>
                        </li>
                        <li class="item">
                          <input id="" type="checkbox" name="industry" />
                          <span class="item-text">Web / Mobile / Gaming </span>
                        </li>
                        <li class="item">
                          <input id="" type="checkbox" name="industry" />
                          <span class="item-text">Food Service</span>
                        </li>
                      </ul>
                    </sui-form-field>
                    <sui-form-field required>
                      <label
                        >What kind of positions are you specialized in?</label
                      >
                      <input
                        type="text"
                        name="line"
                        placeholder="E.g. UX Resercher, Full Stack Developer"
                      />
                    </sui-form-field>
                    <sui-form-field required>
                      <label>Which agency have you worked at?</label>
                      <input
                        type="text"
                        name="line"
                        placeholder="Please provide us an agency you’ve worked at"
                      />
                    </sui-form-field>
                    <sui-form-field class="field upload-button">
                      <label>CV Upload</label>
                      <label id="fileBtn" for="hiddenBtn" class="file"
                        ><i class="las la-paperclip"></i>Select File</label
                      >
                      <input id="hiddenBtn" type="file" />
                      <div class="note">
                        Only .pdf, .doc, .docx files are accepted
                      </div>
                    </sui-form-field>
                    <div class="submit-button">
                      <button class="btn btn-blue" type="submit">Submit</button>
                      <div class="remark">
                        <p>
                          Already have an account?<a class="link" href="/"
                            >Log in</a
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </sui-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Nav from "@/components/layouts/Nav";
import Footer from "@/components/layouts/Footer";
export default {
  name: "RegisterNew",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      current: null,
      options: [
        {
          text: "0-1 Year",
          value: 1,
        },
        {
          text: "2-5 Years",
          value: 2,
        },
        {
          text: "Over 5 Years",
          value: 3,
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
@import "~@/assets/stylesheets/register";
.register-new {
  .upload-button {
    .file {
      background: transparent;
      border: 1px solid $blue-primary;
      border-radius: 100rem;
      /* stylelint-disable-next-line declaration-no-important */
      box-shadow: none !important;
      color: $blue-primary;
      cursor: pointer;
      display: inline-flex;
      filter: contrast(150%);
      font-size: 1em;
      font-weight: 500;
      padding: 1rem 2rem;
      text-align: center;
      text-decoration: none;
      transition: all 0.4s ease-in-out;
      width: fit-content;
    }

    i {
      font-size: 20px;
      margin-right: 5px;
    }
  }
}
</style>
